import { select, takeEvery } from 'redux-saga/effects'

import { sendNoteUploadNotification } from 'helpers/notification'
import { _socket } from 'store/selectors/WebSocket'
import { onConnect } from 'utils/socket'

import * as types from '../actionTypes/WebSocket'

function* _watchReceiveNoteMessage(action) {
    try {
        const {
            noteMsg: {
                note: { name: senderName },
            },
        } = action
        // send notification
        sendNoteUploadNotification({ user: senderName })
    } catch (error) {
        console.log(error)
    }
}

export function* watchReceiveNoteMessage() {
    yield takeEvery(types.SET_NOTE_MESSAGE, _watchReceiveNoteMessage)
}

function* _watchSendSocketMessage(action) {
    try {
        const socket = yield select(_socket)
        onConnect(socket, () => socket.send(action.socketMsg))
    } catch (error) {
        console.log(error)
    }
}

export function* watchSendSocketMessage() {
    yield takeEvery(types.HANDLE_SEND_SOCKET_MESSAGE, _watchSendSocketMessage)
}
